import { ReactNode } from 'react';

import { Job, JobCompanyInfo } from '@kanda-libs/ks-frontend-services';

import BacsPaymentFormElements from './Elements';
import BacsPaymentFormWrapper from './Wrapper';
import BacsPaymentFormProvider from './context';

export interface BascPaymentFormProps {
  job?: Job;
  jobCompanyInfo?: JobCompanyInfo;
  title?: string;
  showHeading?: boolean;
  customHeading?: ReactNode;
}

const BascPaymentForm: React.FunctionComponent<BascPaymentFormProps> =
  function (props) {
    return (
      <BacsPaymentFormProvider {...props}>
        <BacsPaymentFormWrapper>
          <BacsPaymentFormElements />
        </BacsPaymentFormWrapper>
      </BacsPaymentFormProvider>
    );
  };

export default BascPaymentForm;
